function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @typedef Options Configuration.
 * @property {Test} [ignore] `unist-util-is` test used to assert parents
 *
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Content} Content
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Text} Text
 * @typedef {Content|Root} Node
 * @typedef {Extract<Node, import('mdast').Parent>} Parent
 *
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 *
 * @typedef RegExpMatchObject
 * @property {number} index
 * @property {string} input
 *
 * @typedef {string|RegExp} Find
 * @typedef {string|ReplaceFunction} Replace
 *
 * @typedef {[Find, Replace]} FindAndReplaceTuple
 * @typedef {Object.<string, Replace>} FindAndReplaceSchema
 * @typedef {Array.<FindAndReplaceTuple>} FindAndReplaceList
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 * @typedef {Array.<Pair>} Pairs
 */

/**
 * @callback ReplaceFunction
 * @param {...any} parameters
 * @returns {Array.<PhrasingContent>|PhrasingContent|string|false|undefined|null}
 */
import escape from 'escape-string-regexp';
import { visitParents } from 'unist-util-visit-parents';
import { convert } from 'unist-util-is';
var own = {}.hasOwnProperty;
/**
 * @param tree mdast tree
 * @param find Value to find and remove. When `string`, escaped and made into a global `RegExp`
 * @param [replace] Value to insert.
 *   * When `string`, turned into a Text node.
 *   * When `Function`, called with the results of calling `RegExp.exec` as
 *     arguments, in which case it can return a single or a list of `Node`,
 *     a `string` (which is wrapped in a `Text` node), or `false` to not replace
 * @param [options] Configuration.
 */

export var findAndReplace =
/**
 * @type {(
 *   ((tree: Node, find: Find, replace?: Replace, options?: Options) => Node) &
 *   ((tree: Node, schema: FindAndReplaceSchema|FindAndReplaceList, options?: Options) => Node)
 * )}
 **/

/**
 * @param {Node} tree
 * @param {Find|FindAndReplaceSchema|FindAndReplaceList} find
 * @param {Replace|Options} [replace]
 * @param {Options} [options]
 */
function findAndReplace(tree, find, replace, options) {
  /** @type {Options|undefined} */
  var settings;
  /** @type {FindAndReplaceSchema|FindAndReplaceList} */

  var schema;

  if (typeof find === 'string' || find instanceof RegExp) {
    // @ts-expect-error don’t expect options twice.
    schema = [[find, replace]];
    settings = options;
  } else {
    schema = find; // @ts-expect-error don’t expect replace twice.

    settings = replace;
  }

  if (!settings) {
    settings = {};
  }

  var ignored = convert(settings.ignore || []);
  var pairs = toPairs(schema);
  var pairIndex = -1;

  while (++pairIndex < pairs.length) {
    visitParents(tree, 'text', visitor);
  }

  return tree;
  /** @type {import('unist-util-visit-parents').Visitor<Text>} */

  function visitor(node, parents) {
    var index = -1;
    /** @type {Parent|undefined} */

    var grandparent;

    while (++index < parents.length) {
      var parent =
      /** @type {Parent} */
      parents[index];

      if (ignored(parent, // @ts-expect-error mdast vs. unist parent.
      grandparent ? grandparent.children.indexOf(parent) : undefined, grandparent)) {
        return;
      }

      grandparent = parent;
    }

    if (grandparent) {
      return handler(node, grandparent);
    }
  }
  /**
   * @param {Text} node
   * @param {Parent} parent
   * @returns {VisitorResult}
   */


  function handler(node, parent) {
    var find = pairs[pairIndex][0];
    var replace = pairs[pairIndex][1];
    var start = 0; // @ts-expect-error: TS is wrong, some of these children can be text.

    var index = parent.children.indexOf(node);
    /** @type {Array.<PhrasingContent>} */

    var nodes = [];
    /** @type {number|undefined} */

    var position;
    find.lastIndex = 0;
    var match = find.exec(node.value);

    while (match) {
      position = match.index; // @ts-expect-error this is perfectly fine, typescript.

      var value = replace.apply(void 0, _toConsumableArray(match).concat([{
        index: match.index,
        input: match.input
      }]));

      if (typeof value === 'string') {
        value = value.length > 0 ? {
          type: 'text',
          value: value
        } : undefined;
      }

      if (value !== false) {
        if (start !== position) {
          nodes.push({
            type: 'text',
            value: node.value.slice(start, position)
          });
        }

        if (Array.isArray(value)) {
          var _nodes;

          (_nodes = nodes).push.apply(_nodes, _toConsumableArray(value));
        } else if (value) {
          nodes.push(value);
        }

        start = position + match[0].length;
      }

      if (!find.global) {
        break;
      }

      match = find.exec(node.value);
    }

    if (position === undefined) {
      nodes = [node];
      index--;
    } else {
      var _parent$children;

      if (start < node.value.length) {
        nodes.push({
          type: 'text',
          value: node.value.slice(start)
        });
      }

      (_parent$children = parent.children).splice.apply(_parent$children, [index, 1].concat(_toConsumableArray(nodes)));
    }

    return index + nodes.length + 1;
  }
};
/**
 * @param {FindAndReplaceSchema|FindAndReplaceList} schema
 * @returns {Pairs}
 */

function toPairs(schema) {
  /** @type {Pairs} */
  var result = [];

  if (_typeof(schema) !== 'object') {
    throw new TypeError('Expected array or object as schema');
  }

  if (Array.isArray(schema)) {
    var index = -1;

    while (++index < schema.length) {
      result.push([toExpression(schema[index][0]), toFunction(schema[index][1])]);
    }
  } else {
    /** @type {string} */
    var key;

    for (key in schema) {
      if (own.call(schema, key)) {
        result.push([toExpression(key), toFunction(schema[key])]);
      }
    }
  }

  return result;
}
/**
 * @param {Find} find
 * @returns {RegExp}
 */


function toExpression(find) {
  return typeof find === 'string' ? new RegExp(escape(find), 'g') : find;
}
/**
 * @param {Replace} replace
 * @returns {ReplaceFunction}
 */


function toFunction(replace) {
  return typeof replace === 'function' ? replace : function () {
    return replace;
  };
}